import React, { useEffect } from "react";
import { Select, Form } from "antd";
import { connect } from 'react-redux';
import { GET_ROOMS } from '../../../store/actions/room';
import formItemLayout from "../../../const/form/formItemLayout";
const { Option } = Select;

function Rooms({rooms, GET_ROOMS, data, setData, style = { width: "100%" }, optionAll = false }){
    useEffect(() => {
        let body = {
            key: "YOU_SH@LL_P@SS",
            jwt: localStorage.getItem('@Ossel:token')
        };

        GET_ROOMS(body)
    }, []);
  
    return(
        <Form.Item 
            {...formItemLayout} 
            label={"Sala"} 
            hasFeedback
            required={true}
        >
            <Select
                showSearch
                style={style}
                placeholder="Selecione uma Sala"
                optionFilterProp="children"
                onChange={e => setData(data = {...data, room: e})}
                value={data.room}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                loading={rooms.loading}
            >
                {
                    rooms.data.data && rooms.data.data.rooms.map(room => {
                        return <Option key={room._id} value={room._id}>{room.name}</Option>
                    })
                }
            </Select>
        </Form.Item>
    )
}

const mapStateToProps = state => {
    return {
        rooms: state.roomR
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GET_ROOMS: body => dispatch(GET_ROOMS(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rooms);


// WEBPACK FOOTER //
// ./src/components/common/selects/Rooms.jsx